module.exports = __webpack_public_path__ + "img/25-03.929b4c65.png";